import axios from "axios";
import { API_BASE } from "./api";

const TOKEN_KEY = "mabs_admin_token";

export const adminApi = axios.create({
    baseURL: API_BASE,
    timeout: 20000,
    headers: { "Content-Type": "application/json" },
});

adminApi.interceptors.request.use((cfg) => {
    const token = getToken();
    if (token) {
        cfg.headers = cfg.headers || {};
        cfg.headers.Authorization = `Bearer ${token}`;
    }
    return cfg;
});

export function getToken() {
    try {
        return window.localStorage.getItem(TOKEN_KEY) || "";
    } catch {
        return "";
    }
}

export function setToken(token) {
    try {
        if (token) window.localStorage.setItem(TOKEN_KEY, token);
        else window.localStorage.removeItem(TOKEN_KEY);
    } catch {
        /* ignore */
    }
}

export function extractApiError(err, fallback = "Une erreur est survenue.") {
    const detail = err?.response?.data?.detail;
    if (!detail) return err?.message || fallback;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : ""))
            .filter(Boolean)
            .join(" · ") || fallback;
    }
    if (typeof detail === "object" && detail.message) return detail.message;
    return fallback;
}

export function isPasswordChangeRequired(err) {
    return err?.response?.data?.detail?.code === "PASSWORD_CHANGE_REQUIRED";
}
